import clsx from 'clsx';

export function ContainerSection({ className, ...props }) {
  return (
    <section className={clsx('mx-auto max-w-7xl px-4 sm:px-6 lg:px-8', className)}
      {...props}
    />
  );
}
